var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile card",class:{
    'tile--focusable': _vm.focusable && !_vm.disabled,
    'tile--selected': _vm.selected && !_vm.disabled,
    'tile--disabled': _vm.disabled,
    [`tile--${_vm.type}`]: true
  },attrs:{"tabindex":_vm.enabled ? 0 : ''},on:{"keyup":_vm.onKeyUp,"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }